:host {
  height: auto;
}

#additional-targets-section {
  width: 870px;
}

.remove-content-form-margin {
  margin-left: calc(-1 * var(--spacer) / 2);
}

.form-field-input-misc-accordion {
  width: 455px;
  margin-top: calc(var(--spacer) * 1.5);
}

.form-section {
  margin-bottom: calc(var(--spacer) * 4);

  .flex-group {
    display: flex;
    align-items: flex-start;

    .module-icon {
      margin-top: calc(var(--spacer) * 1.5);
      width: 39px;
      color: var(--chart-302-icon-buttons-titles);
    }
  }
}

gz-info-box {
  padding: calc(2 * var(--spacer)) 0 0;
  line-height: 18px;
  --info-box-max-width: 870px;
}

.info-box-style::part(container) {
  padding: unset;
  width: 870px;
}
